import React from 'react'

export const Logo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="947.95 422.25 664.1 539.42"
    {...props}
  >
    <path
      d="m0 0 101.681-67.044 149.417-236.015v-93.395z"
      style={{
        fill: '#022856',
        fillOpacity: 1,
        fillRule: 'nonzero',
        stroke: 'none',
      }}
      transform="matrix(1.33333 0 0 -1.33333 947.957 433.029)"
    />
    <path
      d="m0 0 97.7-64.118 281.011-.519L479.145.897Z"
      style={{
        fill: '#02318b',
        fillOpacity: 1,
        fillRule: 'nonzero',
        stroke: 'none',
      }}
      transform="matrix(1.33333 0 0 -1.33333 963.733 423.462)"
    />
    <path
      d="m0 0 131.525-208.113-3 148.882z"
      style={{
        fill: '#3999bf',
        fillOpacity: 1,
        fillRule: 'nonzero',
        stroke: 'none',
      }}
      transform="matrix(1.33333 0 0 -1.33333 1107.422 531.76)"
    />
    <path
      d="m0 0-97.434-64.244-138.346-239.894-.121-93.116z"
      style={{
        fill: '#3798c2',
        fillOpacity: 1,
        fillRule: 'nonzero',
        stroke: 'none',
      }}
      transform="matrix(1.33333 0 0 -1.33333 1612.043 431.963)"
    />
    <path
      d="m0 0-121.447-211.65-1.386 149.445L2.315 1.172"
      style={{
        fill: '#02318b',
        fillOpacity: 1,
        fillRule: 'nonzero',
        stroke: 'none',
      }}
      transform="matrix(1.33333 0 0 -1.33333 1457.65 528.203)"
    />
    <path
      d="M0 0h240.16L125.388-58.891Z"
      style={{
        fill: '#042858',
        fillOpacity: 1,
        fillRule: 'nonzero',
        stroke: 'none',
      }}
      transform="matrix(1.33333 0 0 -1.33333 1119.391 522.65)"
    />
  </svg>
)
